import { FC } from "react";
import { Container } from "./Container.styles";

interface WrapperProps {
  children: React.ReactNode;
}

const Warapper: FC<WrapperProps> = ({ children }) => {
  return <Container>{children}</Container>;
};

export default Warapper;
